export default __webpack_public_path__ + "static/media/Nunito-BlackItalic.f38a88b0.woff";